import { useGetProjectQuery } from 'features/entry-form-v2/data/useGetProjectQuery';
import { useFlag } from 'features/hooks/useFlag';
import { useParams } from 'react-router-dom';

export const useIsCodelistFeatureEnabled = () => {
	return useFlag('teamCoreCodelistCodelistEnabled');
};

// The flag is set per workspace, so it can be off for collaborators from other workspaces.
export const useIsCodelistEnabledForProject = (): boolean => {
	const { projectId, id } = useParams<{ projectId?: string; id?: string }>();

	const projectQuery = useGetProjectQuery(
		{ projectId: (projectId ?? id) as string },
		{ enabled: !!(projectId || id) }
	);

	return !!projectQuery.data?.project.keyId;
};
